import type { TripPassengerTag } from '@bambi/api-client/schemas';

import { TagDisplay } from 'src/common/tags/TagDisplay/TagDisplay';

interface PassengerTagsDisplayProps {
  tags?: TripPassengerTag[] | null;
}

export function PassengerTagsDisplay({
  tags,
}: PassengerTagsDisplayProps): JSX.Element | null {
  if (!tags?.length) {
    return null;
  }

  return <TagDisplay tags={tags} />;
}
